import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexModal',
  setup(__props) {

const basicModal = defineAsyncComponent(() => import("@/components/theme/uikits/modal/basicModal.vue"))
const sizeModel = defineAsyncComponent(() => import("@/components/theme/uikits/modal/sizeModel.vue"))
const fullscreenModal = defineAsyncComponent(() => import("@/components/theme/uikits/modal/fullscreenModal.vue"))
const centeredModal = defineAsyncComponent(() => import("@/components/theme/uikits/modal/centeredModal.vue"))
const toggleModals = defineAsyncComponent(() => import("@/components/theme/uikits/modal/toggleModals.vue"))
const staticModal = defineAsyncComponent(() => import("@/components/theme/uikits/modal/staticModal.vue"))
const customModals = defineAsyncComponent(() => import("@/components/theme/uikits/modal/customModals.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      title: "Modal"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(basicModal)),
        _createVNode(_unref(sizeModel)),
        _createVNode(_unref(fullscreenModal)),
        _createVNode(_unref(centeredModal)),
        _createVNode(_unref(toggleModals)),
        _createVNode(_unref(staticModal)),
        _createVNode(_unref(customModals))
      ])
    ])
  ], 64))
}
}

})